import {CellStyle} from './CellStyle';
import {XlsPivotConfiguration} from './XlsPivotConfiguration';

export class XlsConfiguration {
cellStyle: CellStyle;
headerStyle: CellStyle;
mode: string;
pivot: XlsPivotConfiguration;
}

